import http from './http'
//获取地址列表
export function getadressList (id){
    return http.get('/api/park/get_area_list?service_id='+id)
}

//发送表单
export function postList (list){
    return http.post('/api/park/save',list)
}

//获取预约信息
export function getlistdata (data){
    return http.get('/api/park/order_list?page='+data.page+'&&limit='+data.limit)
}
